var _path, _path2, _path3, _path4;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgReferal(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.75 1.5C4.785 1.5 3.1875 3.0975 3.1875 5.0625C3.1875 6.99 4.695 8.55 6.66 8.6175C6.72 8.61 6.78 8.61 6.825 8.6175C6.84 8.6175 6.8475 8.6175 6.8625 8.6175C6.87 8.6175 6.87 8.6175 6.8775 8.6175C8.7975 8.55 10.305 6.99 10.3125 5.0625C10.3125 3.0975 8.715 1.5 6.75 1.5Z",
    fill: "#677481"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.5597 10.6125C8.46723 9.2175 5.05473 9.2175 2.94723 10.6125C1.99473 11.25 1.46973 12.1125 1.46973 13.035C1.46973 13.9575 1.99473 14.8125 2.93973 15.4425C3.98973 16.1475 5.36973 16.5 6.74973 16.5C8.12973 16.5 9.50973 16.1475 10.5597 15.4425C11.5047 14.805 12.0297 13.95 12.0297 13.02C12.0222 12.0975 11.5047 11.2425 10.5597 10.6125Z",
    fill: "#677481"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M14.992 5.505C15.112 6.96 14.077 8.235 12.6445 8.4075C12.637 8.4075 12.637 8.4075 12.6295 8.4075H12.607C12.562 8.4075 12.517 8.4075 12.4795 8.4225C11.752 8.46 11.0845 8.2275 10.582 7.8C11.3545 7.11 11.797 6.075 11.707 4.95C11.6545 4.3425 11.4445 3.7875 11.1295 3.315C11.4145 3.1725 11.7445 3.0825 12.082 3.0525C13.552 2.925 14.8645 4.02 14.992 5.505Z",
    fill: "#677481"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M16.4922 12.4425C16.4322 13.17 15.9672 13.8 15.1872 14.2275C14.4372 14.64 13.4922 14.835 12.5547 14.8125C13.0947 14.325 13.4097 13.7175 13.4697 13.0725C13.5447 12.1425 13.1022 11.25 12.2172 10.5375C11.7147 10.14 11.1297 9.825 10.4922 9.5925C12.1497 9.1125 14.2347 9.435 15.5172 10.47C16.2072 11.025 16.5597 11.7225 16.4922 12.4425Z",
    fill: "#677481"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgReferal);
export default __webpack_public_path__ + "static/media/Referal.5d9a396ab3322560dd39ea07394a95f5.svg";
export { ForwardRef as ReactComponent };